import {withPayloadType} from '@lib/utils';
import {Variant} from './types';
import {createAction} from '@reduxjs/toolkit';

export const setActiveVariant = createAction('usability/setActiveVariant', withPayloadType<Variant>());
